export default __webpack_public_path__ + "static/external_site-5fac2f83b30603a2777b49b93ce814ae.mp4";